import { getStores } from '@/stores'
import React from 'react'

const useNodeSubmitDisabledStatus = (props: { messageId: string; initialDisabled: boolean }) => {
  const { messageId, initialDisabled } = props
  const { agentV2Store } = getStores()

  const setSubmitDisabled = (disabled: boolean) => {
    agentV2Store.nodeDisalbedStatusMap[messageId] = disabled
  }

  React.useEffect(() => {
    if (initialDisabled) {
      setSubmitDisabled(true)
    }
  }, [])

  const submitDisabled = agentV2Store.nodeDisalbedStatusMap[messageId] || false

  const obj = {
    submitDisabled: submitDisabled,
    setSubmitDisabled
  }

  return obj
}

export default useNodeSubmitDisabledStatus
